import { render, staticRenderFns } from "./table-popover.vue?vue&type=template&id=83b73948&scoped=true"
import script from "./table-popover.vue?vue&type=script&lang=ts"
export * from "./table-popover.vue?vue&type=script&lang=ts"
import style0 from "./table-popover.vue?vue&type=style&index=0&id=83b73948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b73948",
  null
  
)

export default component.exports